import { useState } from 'react';

export const useToast = () => {
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState('success');

  const showToast = (message, severity = 'success') => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  const toastProps = {
    open: toastOpen,
    autoHideDuration: 3000,
    onClose: () => setToastOpen(false),
    anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
    message: toastMessage,
    severity: toastSeverity
  };

  return { showToast, toastProps };
};
